import appsettings from "@/store/app-settings";
import * as userData from "@/auth/localStorageUtils.js";

const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const isGuid = function(value) {
  return typeof value === "string" && guidPattern.test(value.trim());
};

// origin ของแอป Digital ID ใช้ตรวจ event.origin ตอนรับ postMessage จาก iframe
const digitalIdOrigin = function() {
  try {
    return new URL(appsettings.digitalIdBackendUrl).origin;
  } catch (error) {
    console.log("digitalIdOrigin", error);
    return null;
  }
};

// AuthId ที่ส่งเข้า iframe ถ้าไม่ใช่ GUID แอป Digital ID จะเด้งไปหน้า login ของตัวเอง
// (สำหรับ role admin ค่านี้คือ selectedAdminOfficer ซึ่งอาจว่างได้)
const authId = function() {
  try {
    const id = userData.userId();
    return isGuid(id) ? id.trim() : null;
  } catch (error) {
    console.log("digitalIdEmbed.authId", error);
    return null;
  }
};

// ประกอบ URL ใหม่ทุกครั้งที่เปิด modal เพื่อให้ browser โหลด iframe ใหม่เสมอ
// คืน null เมื่อไม่มี AuthId ที่ใช้ได้ เพื่อไม่ให้เปิด URL ที่การันตีว่าจะเด้งไป login
const buildUrl = function(path, params) {
  const auth = authId();
  if (auth === null) {
    return null;
  }

  const query = new URLSearchParams();
  query.set("AuthId", auth);
  // ไม่ส่ง ParentUrl: แอป Digital ID เอาค่านี้ไปหาใน WebConfig:ComplaintBackendWebSite
  // ถ้าหาไม่เจอจะได้ null แล้ว view พังเป็น NullReferenceException กลายเป็นหน้า login
  // ปล่อยให้ fallback เป็นรายการแรกของ config ซึ่งคือ origin ของระบบร้องทุกข์อยู่แล้ว

  // caller ส่งค่า add mode มาปนกันทั้ง -1, "" และ undefined
  // แอป Digital ID รับได้แค่ GUID หรือค่าว่าง
  Object.keys(params || {}).forEach(function(key) {
    query.set(key, isGuid(params[key]) ? params[key].trim() : "");
  });

  query.set("time", Date.now());

  return `${appsettings.digitalIdBackendUrl}${path}?${query.toString()}`;
};

export { isGuid, digitalIdOrigin, authId, buildUrl };
